import apiClient from '../../../core/api/client';

// The shared apiClient uses `validateStatus: status < 500`, so axios
// resolves on 4xx instead of throwing. Family endpoints respond with
// 404 (FAMILY_NOT_FOUND) and 403 (NOT_OWNER) for normal states that
// callers in this module treat as errors. Unwrap responses here so the
// public API of this file matches "if it resolves, you got valid data".
const unwrap = (res) => {
  if (res.status >= 400) {
    const err = new Error(res.data?.message || `Request failed (${res.status})`);
    err.response = res;
    throw err;
  }
  return res.data;
};

const expect2xx = (res) => {
  if (res.status >= 400) {
    const err = new Error(res.data?.message || `Request failed (${res.status})`);
    err.response = res;
    throw err;
  }
};

// ---------------------------------------------------------------
// Family lifecycle
// ---------------------------------------------------------------

export const getFamily          = async ()       => unwrap(await apiClient.get('/api/family'));
export const createFamily       = async (name)   => unwrap(await apiClient.post('/api/family', name ? { name } : {}));
export const renameFamily       = async (name)   => unwrap(await apiClient.patch('/api/family', { name }));
export const disbandFamily      = async ()       => expect2xx(await apiClient.delete('/api/family'));
export const leaveFamily        = async ()       => expect2xx(await apiClient.post('/api/family/leave'));
export const removeMember       = async (userId) => expect2xx(await apiClient.delete(`/api/family/members/${userId}`));
export const updateMyMembership = async (payload) => unwrap(await apiClient.patch('/api/family/members/me', payload));

// ---------------------------------------------------------------
// Invitations
// ---------------------------------------------------------------

export const createInvitation  = async (payload = {}) => unwrap(await apiClient.post('/api/family/invitations', payload));
export const listInvitations   = async ()       => unwrap(await apiClient.get('/api/family/invitations'));
export const revokeInvitation  = async (id)     => expect2xx(await apiClient.delete(`/api/family/invitations/${id}`));
export const deleteInvitation  = async (id)     => expect2xx(await apiClient.delete(`/api/family/invitations/${id}/inactive`));
export const previewInvitation = async (token)  => unwrap(await apiClient.get(`/api/family/invitations/preview/${token}`));
export const acceptInvitation  = async (token)  => unwrap(await apiClient.post(`/api/family/invitations/accept/${token}`));

// ---------------------------------------------------------------
// Family-scoped reads
// ---------------------------------------------------------------

export const getFamilyReceipts          = async (from, to)  => unwrap(await apiClient.get('/api/family/receipts', { params: { from, to } }));
export const getFamilyCards             = async ()           => unwrap(await apiClient.get('/api/family/cards'));
export const getFamilyStatements        = async (from, to)  => unwrap(await apiClient.get('/api/family/statements', { params: { from, to } }));
export const getFamilyTransactions      = async (from, to)  => unwrap(await apiClient.get('/api/family/transactions', { params: { from, to } }));
export const getFamilyDebtForecast      = async (months=12) => unwrap(await apiClient.get('/api/family/reports/debt-forecast', { params: { months } }));
